<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<div class="img_containerp">
<img alt="images" src="images/pub1.jpg"/>
</div>
<p class="copy1"><span class="bold">Henry VIII in 100 Objects</span></p>
<p class="copy1">This edition published in 2020 by Frontline Books,</p>
<p class="copy">An imprint of Pen &amp; Sword Books Ltd,</p>
<p class="copy">Yorkshire - Philadelphia</p>
<p class="copy1">Copyright © Paul Kendall, 2020</p>
<p class="copy1">The right of Paul Kendall to be identified as the author of this work has been asserted by him in accordance with the Copyright, Designs and Patents Act 1988.</p>
<p class="copy1">HB ISBN 978 1 52673 128 9</p>
<p class="copy">PB ISBN 978 1 52676 719 6</p>
<p class="copy">Mobi ISBN 978 1 52673  130 2</p>
<p class="copy1">All rights reserved. No part of this publication may be reproduced, stored in or introduced into a retrieval system, or transmitted, in any form, or by any means (electronic, mechanical, photocopying, recording or otherwise) without the prior written permission of the publisher. Any person who does any unauthorized act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="copy1">CIP data records for this title are available from the British Library</p>
<p class="copy1">Pen &amp; Sword Books Limited incorporates the imprints of Atlas, Archaeology, Aviation, Discovery, Family History, Fiction, History, Maritime, Military, Military Classics, Politics, Select, Transport, True Crime, Air World, Frontline Publishing, Leo Cooper, Remember When, Seaforth Publishing, The Praetorian Press, Wharncliffe Local History, Wharncliffe Transport, Wharncliffe True Crime and White Owl.</p>
<p class="copy1">PEN &amp; SWORD BOOKS LTD</p>
<p class="copy">47 Church Street, Barnsley, South Yorkshire, S70 2AS, England</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:enquiries@pen-and-sword.co.uk"><span class="underline">enquiries@pen-and-sword.co.uk</span></a></span></p>
<p class="copy">Website: <span class="weblink"><a href="http://www.pen-and-sword.co.uk" target="_blank"><span class="underline">www.pen-and-sword.co.uk</span></a></span></p>
<p class="copy1">Or</p>
<p class="copy">PEN AND SWORD BOOKS</p>
<p class="copy">1950 Lawrence Rd, Havertown, PA 19083, USA</p>
<p class="copy">E-mail: <span class="weblink"><a href="mailto:Uspen-and-sword@casematepublishers.com"><span class="underline">Uspen-and-sword@casematepublishers.com</span></a></span></p>
<p class="copy1">For more information on our books, please visit</p>
<p class="copy"><span class="weblink"><a href="http://www.frontline-books.com" target="_blank"><span class="underline">www.frontline-books.com</span></a></span>, email <span class="weblink"><a href="mailto:info@frontline-books.com"><span class="underline">info@frontline-books.com</span></a></span></p>
<p class="copy">or write to us at the above address.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_Copyright.vue?3a1a8d3a